import { put, select, take, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditUserPayload } from '@app-store/slices/users/edit'
import { RootState } from '@app-store/store'

interface TaskAction extends Action {
    payload: IEditUserPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.users.edit
const { onRequest: changeStatus } = rootActions.users.changeStatus
const { toggleUserModal } = rootActions.ui.settings
const { onRequest: getPreSignedUploadURL } = rootActions.users.getPreSignedUpload
const { onRequest: fileUpload } = rootActions.users.uploadImage
function* editUserSagaTask({ payload }) {
    try {
        if (payload.avatar && payload.avatar.fileList && payload.avatar.fileList[0]) {
            yield put(getPreSignedUploadURL())
            yield take('user/get-presigned-upload-URL/onSuccess')
            const { file } = yield select((store: RootState) => store.users.getPreSignedUpload.data)
            yield put(fileUpload(payload.avatar.fileList[0]))
            yield take('user/upload-image/onSuccess')
            payload.data.avatar = file
        } else if (typeof payload.avatar !== 'string') {
            payload.data.avatar = null
        }
        yield put(changeStatus({ id: payload.id, status: payload.data.status ? 'Inactive' : 'Active' }))
        const newData = {
            avatar: payload.data.avatar,
            confirm_password: payload.data.confirm_password,
            email: payload.data.email,
            firstname: payload.data.firstname,
            lastname: payload.data.lastname,
            mobile: payload.data.mobile,
            password: payload.data.password,
            role: payload.data.role
        }
        const response = yield axios.put(`/users/${payload.id}`, { ...newData })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(toggleUserModal({}))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editUserSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editUserSagaTask)
}

export default editUserSaga
